export const SET_PRINT = 'SET_PRINT';

export const setPrintValueAction = data => ({ type: SET_PRINT, data });
